export default __webpack_public_path__ + "static/media/writing-notes.4d0ee68b.svg";